module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia1-61f3b1ac1d71b098bf7ebe45ee709548.jpg";